import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import cn from 'classnames';
import styles from './CircularLoader.module.scss';
let nextGradientId = 0;
const COLOR_HEX = {
    primary: 'var(--button-primary, #6942f8)',
    inverted: '#FFFFFF',
    danger: '#E86161',
    monochrome: '#282863'
};
export function CircularLoader(props) {
    const { className, size = 24, centeredInBox, centerBoxHeight, centerBoxWidth, style, testId, color = 'primary' } = props, rest = _object_without_properties(props, [
        "className",
        "size",
        "centeredInBox",
        "centerBoxHeight",
        "centerBoxWidth",
        "style",
        "testId",
        "color"
    ]);
    const gradientIdRef = useRef(null);
    if (gradientIdRef.current == null) {
        gradientIdRef.current = "loaderGradient".concat(++nextGradientId);
    }
    const gradientId = gradientIdRef.current;
    const stopColor = COLOR_HEX[color];
    const loader = /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        className: cn(styles.circularLoader, className),
        width: size,
        height: size,
        viewBox: "0 0 50 50",
        style: style,
        "data-testid": testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: gradientId,
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "0%",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0%",
                            style: {
                                stopColor
                            },
                            stopOpacity: "1"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "20%",
                            style: {
                                stopColor
                            },
                            stopOpacity: "0.8"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "50%",
                            style: {
                                stopColor
                            },
                            stopOpacity: "0.5"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "95%",
                            style: {
                                stopColor
                            },
                            stopOpacity: "0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("circle", {
                className: styles.circle,
                cx: "25",
                cy: "25",
                r: "20",
                strokeWidth: "8.5",
                stroke: "url(#".concat(gradientId, ")")
            })
        ]
    }));
    return centeredInBox ? /*#__PURE__*/ _jsx("div", {
        className: styles.centeredBox,
        style: {
            height: centerBoxHeight,
            width: centerBoxWidth
        },
        children: loader
    }) : loader;
}
